
export const leadsInitialState = {
    sentCards : null ,
    receivedCards : null,
    requestReceivedList : null,
    initialLoading : false,
    addToMarketplace : false,
}